var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hiper",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_121",
    "data-name": "Caminho 121",
    d: "M40,21.875A3.244,3.244,0,0,1,36.667,25H3.333A3.244,3.244,0,0,1,0,21.875V3.125A3.244,3.244,0,0,1,3.333,0H36.667A3.244,3.244,0,0,1,40,3.125Z",
    fill: "#ff7900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_122",
    "data-name": "Caminho 122",
    d: "M36.667,0H3.333A3.244,3.244,0,0,0,0,3.125v18.75A3.244,3.244,0,0,0,3.333,25H36.667A3.244,3.244,0,0,0,40,21.875V3.125A3.244,3.244,0,0,0,36.667,0Zm0,.625a2.59,2.59,0,0,1,2.667,2.5v18.75a2.59,2.59,0,0,1-2.667,2.5H3.333a2.59,2.59,0,0,1-2.667-2.5V3.125A2.59,2.59,0,0,1,3.333.625Z",
    fill: "none",
    opacity: 0.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_30",
    "data-name": "Grupo 30",
    transform: "translate(9.931 9.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_123",
    "data-name": "Caminho 123",
    d: "M13.891,17.911c0-.957,0-1.914,0-2.871,0-.119.028-.161.154-.159.361.008.722.007,1.084,0,.117,0,.151.034.149.149-.005.669,0,1.338-.005,2.007,0,.127.031.168.163.167q.974-.01,1.948,0c.117,0,.148-.034.148-.149,0-.674,0-1.347,0-2.021,0-.112.024-.154.144-.153.366.007.732.009,1.1,0,.141,0,.142.064.142.169q0,2.512,0,5.024c0,.254,0,.507,0,.761,0,.1-.033.126-.126.125q-.563-.007-1.128,0c-.1,0-.132-.031-.132-.133,0-.752,0-1.5,0-2.256,0-.129-.035-.166-.165-.164-.644.007-1.289.006-1.933,0-.121,0-.161.036-.159.158,0,.747,0,1.494,0,2.241,0,.126-.038.156-.157.154q-.542-.01-1.084,0c-.114,0-.146-.034-.146-.149C13.894,19.845,13.892,18.878,13.891,17.911Z",
    transform: "translate(-13.889 -14.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_124",
    "data-name": "Caminho 124",
    d: "M26.66,20.105c0,.278,0,.513,0,.747,0,.082.021.127.114.127.224,0,.449.019.673.014a.846.846,0,0,0,.814-.5,1.7,1.7,0,0,0,.034-1.4.8.8,0,0,0-.91-.547.857.857,0,0,0-.71.8C26.643,19.612,26.671,19.881,26.66,20.105Zm-.141-1.931a1.672,1.672,0,0,1,1.376-.71,1.744,1.744,0,0,1,1.67,1.067,3.052,3.052,0,0,1,.194,1.746,2.012,2.012,0,0,1-.518,1.137,2.086,2.086,0,0,1-1.359.6c-.321.034-.644.016-.966.019-.28,0-.254-.029-.255.248,0,.43,0,.859,0,1.289,0,.1-.028.136-.132.134-.361-.006-.722-.006-1.084,0-.108,0-.142-.026-.141-.138.006-.435,0-.869,0-1.3,0-.232,0-.229-.228-.244a2.316,2.316,0,0,1-.978-.267,1.891,1.891,0,0,1-.961-1.423,4.472,4.472,0,0,1-.049-.817c0-.611,0-1.221,0-1.831,0-.1.023-.137.13-.135.371.006.743.007,1.113,0,.112,0,.141.033.14.141,0,.713-.01,1.426,0,2.139a1.259,1.259,0,0,0,.351.932.794.794,0,0,0,.343.188c.09.026.143.013.142-.108,0-1,.009-2.011-.045-3.015,0-.009,0-.02,0-.029,0-.271-.019-.224.226-.226.274,0,.547,0,.821,0,.115,0,.152.036.154.151A4.3,4.3,0,0,0,26.519,18.174Z",
    transform: "translate(-17.34 -15.642)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_125",
    "data-name": "Caminho 125",
    d: "M23.761,15.926a.665.665,0,0,1-.731-.69.735.735,0,0,1,1.468.016A.673.673,0,0,1,23.761,15.926Z",
    transform: "translate(-17.317 -14.549)",
    fill: "#ffe701"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_126",
    "data-name": "Caminho 126",
    d: "M36.456,19.227c.229,0,.458,0,.688,0,.068,0,.113-.011.106-.1a.752.752,0,0,0-1.025-.742.893.893,0,0,0-.568.755c-.018.087.041.082.1.082Zm.613.939c-.424,0-.849,0-1.274,0-.1,0-.152.011-.111.14a.946.946,0,0,0,.8.638,3.263,3.263,0,0,0,1.5-.1c.094-.024.124-.006.14.08.044.234.088.468.139.7.022.1-.031.139-.114.166a4.557,4.557,0,0,1-1.538.223,2.539,2.539,0,0,1-1.323-.352,1.88,1.88,0,0,1-.876-1.319,2.648,2.648,0,0,1,.22-1.749,2.206,2.206,0,0,1,2.956-.9,1.788,1.788,0,0,1,.8,1.054,2.93,2.93,0,0,1,.1,1.328c-.016.1-.078.094-.146.094C37.918,20.167,37.493,20.167,37.069,20.167Z",
    transform: "translate(-21.563 -15.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_127",
    "data-name": "Caminho 127",
    d: "M41.775,20.038c0-.4,0-.791,0-1.186s-.012-.8-.026-1.2c0-.1.029-.122.122-.121.307.005.615.007.922,0,.106,0,.136.039.139.131.005.176.011.351.019.526,0,.033,0,.078.035.088s.047-.038.061-.067a1.3,1.3,0,0,1,.887-.743,1.793,1.793,0,0,1,.466-.019c.082,0,.073.064.073.116,0,.351,0,.7,0,1.054,0,.1-.033.129-.129.111a1.145,1.145,0,0,0-.7.071.866.866,0,0,0-.5.882c0,.693,0,1.386,0,2.079,0,.133-.041.164-.166.161-.356-.007-.713-.007-1.068,0-.109,0-.141-.03-.141-.141C41.777,21.2,41.775,20.619,41.775,20.038Z",
    transform: "translate(-24.336 -15.633)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiper);
export default __webpack_public_path__ + "static/media/hiper.6440741aba00bbf8bc0570dd06482b1d.svg";
export { ForwardRef as ReactComponent };